import React, {PropTypes, Component} from 'react';
import utils from '../../../utils/utils';

const s = require('./search.scss');

class Search extends Component {
  render() {
    const {search, filter, fetchPosts, tag, locale} = this.props;
    return (
      <div className={s.form}>
        <label htmlFor="search">
          <input
            value={filter}
            data-hook="navigation-search-input" type="search" name="search" placeholder={locale.search_pleaceholder}
            onChange={e => search(e.target.value)}
            onKeyPress={e => {
              if (e.charCode === 13) {
                search(e.target.value);
                fetchPosts({tag, filter, baseURL: window.basePath});
              }
            }}
            />
          <button
            data-hook="navigation-search-button"
            onClick={() => {
              utils.reportBi('333', `search_term=${filter}`);
              fetchPosts({tag, filter, baseURL: window.basePath});
            }}
            >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 19" width="19" height="19">
              <path
                d="M19,18.06l-3.84-3.85a8.32,8.32,0,0,0,2-5.6,8.6,8.6,0,1,0-8.6,8.6,8.61,8.61,0,0,0,5.68-2L18.06,19ZM8.6,15.88A7.28,7.28,0,1,1,15.88,8.6,7.29,7.29,0,0,1,8.6,15.88Z"
                />
            </svg>
          </button>
          <hr/>
        </label>
      </div>
    );
  }
}

Search.propTypes = {
  filter: PropTypes.string.isRequired,
  tag: PropTypes.string.isRequired,
  search: PropTypes.func.isRequired,
  fetchPosts: PropTypes.func.isRequired,
  locale: PropTypes.object.isRequired
};

export default Search;



// WEBPACK FOOTER //
// ./components/partial/Search/Search.js